var map = {
	"./auth.js": "11c0",
	"./customers.js": "6d1f",
	"./merchants.js": "6c72",
	"./notifications.js": "b67d",
	"./products.js": "22ca",
	"./purchases.js": "8091",
	"./stores.js": "0d56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";